/* eslint-disable */
import React, { useState,useEffect } from "react";
import {
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarBrand,
  Navbar,
  Nav,
  NavItem,
  NavLink,
  NavbarToggler,
  Collapse,
} from "reactstrap";
import { connect } from "dva";

import logo from "../../assets/images/logos/logo.png";
import route_map from "../../config/route_map";

import LoginModal from "../login/login";
import RegisterModal from "../login/register";
import ForgetModal from "../login/forget";
import ResetModal from "../login/reset";
import BfxForgetModal from "../login/bfxForget";
import Login2faModal from "../login/Login2fa"
import PwdResetModal from "../login/resetpwd"

// other
import Cookie from "../../utils/cookie"

// 多语言
import { useTranslation } from "react-i18next";


const HeaderComponent = ({ layout, dispatch }) => {

  const { t, i18n } = useTranslation();
  const langMap = {
    "ja-jp": "🇯🇵 日本語",
    "en-us": "🇺🇸 English",
  };

  const [isOpen, setIsOpen] = useState(false);
  const [headerLangLabel, setHeaderLangLabel] = useState(langMap[layout.lang]);
  let userinfoAtsession = window.sessionStorage.getItem("userinfo") ? JSON.parse(window.sessionStorage.getItem("userinfo")) : {email:""};


  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };


  const changeLang = (lang, e) => {
    e.preventDefault();
     dispatch({
       type: "layout/save",
       payload: {
         lang: lang,
       },
     });
    changeLanguage(lang);
    setHeaderLangLabel(langMap[lang])
    Cookie.write({ name: "locale", value: lang });
  };
  

  const loginToggle = async () => {
    dispatch({
      type: "layout/save",
      payload: {
        loginModal: !layout.loginModal,
      },
    });
  };

  const registerToggle = async () => {
    dispatch({
      type: "layout/save",
      payload: {
        registerModal: !layout.registerModal,
      },
    });
  };

  const bfxForgetToggle = async (e) => {
    e.preventDefault();
    dispatch({
      type: "layout/save",
      payload: {
        bfxForgetModal: !layout.bfxForgetModal,
      },
    });
  };

  const logout = () => {
    dispatch({
      type: "layout/save",
      payload: {
        is_login: !layout.is_login,
        userinfo: {}
      },
    });
    window.sessionStorage.removeItem("userinfo");
    Cookie.del("user_id");
    window.location.href = route_map.index;
  };

  useEffect(() => {
    if (Cookie.read("user_id")) {
      dispatch({
        type: "layout/save",
        payload: {
          is_login: true,
        },
      });
    }else {
        dispatch({
          type: "layout/save",
          payload: {
            is_login: false,
          },
        });
    }
  }, [Cookie.read("user_id")]);

  useEffect(() => {
     if (Cookie.read("locale")) {
        dispatch({
          type: "layout/save",
          payload: {
            lang: Cookie.read("locale"),
          },
        });
        changeLanguage(Cookie.read("locale"));
        setHeaderLangLabel(langMap[Cookie.read("locale")]);
     } else {
       dispatch({
         type: "layout/save",
         payload: {
           lang: "ja-jp",
         },
       });
       Cookie.write({name:"locale", value:"ja-jp"});
     }
  }, [Cookie.read("locale")]);


  let userinfo =  layout.userinfo && layout.userinfo.data ? layout.userinfo.data : {}
  const toggle = () => setIsOpen(!isOpen);
  return (
    <div
      className="header1 po-relative bg-dark"
      style={{ padding: "0 8% 0 20px" }}
    >
      <Navbar className="navbar-expand-lg h2-nav">
        <NavbarBrand href="/">
          <img width="45%" src={logo} alt="^_^" />
          {/* <Button
            className="btn-danger-gradiant btn-sm animate__animated animate__bounce animate__repeat-3"
            onClick={bfxForgetToggle}
          >
            <span className="btn-label">
             
            </span>{" "}
            BtxFXユーザ移転（初回）
          </Button> */}
        </NavbarBrand>
        <NavbarToggler onClick={toggle}>
          <span className="ti-menu text-white"></span>
        </NavbarToggler>
        <Collapse isOpen={isOpen} navbar id="header1">
          <Nav navbar className="ml-auto mt-2 mt-lg-0">
            {/* <NavItem className="active">
              <NavLink href="/">ホーム</NavLink>
            </NavItem> */}

            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav>
                {t("Products")}
                <i className="fa fa-angle-down m-l-5"></i>
              </DropdownToggle>
              <DropdownMenu className="b-none animate__animated animate__fadeInUp animate__faster">
                <DropdownItem>
                  <a href="/eos">{t("EOS Delegate")}</a>
                </DropdownItem>
                <DropdownItem>
                  <a href="/dot">{t("Polkadot Staking")}</a>
                </DropdownItem>
                <DropdownItem>
                  <a href="/filecoin">{t("Filecoin Mining")}</a>
                </DropdownItem>
                <DropdownItem>
                  <a href="/chia">{t("Chia Farming")}</a>
                </DropdownItem>

                <DropdownItem>
                  <a href="/eth2">{t("ETH2.0 Staking")}</a>
                </DropdownItem>
                <DropdownItem>
                  <a href="/solana">{t("Solana Staking")}</a>
                </DropdownItem>
                <DropdownItem>
                  <a href="/near">{t("Near Staking")}</a>
                </DropdownItem>
                <DropdownItem>
                  <a href="/mina">{t("Mina Staking")}</a>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            {layout.is_login ? (
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav>
                  <span className="btn-label">
                    <i className="fa fa-user m-r-5"></i>
                    <i className="fa fa-angle-down m-l-5"></i>
                  </span>{" "}
                </DropdownToggle>
                <DropdownMenu
                  className="b-none animate__animated animate__fadeInUp 
 animate__faster"
                >
                  <DropdownItem>
                    {userinfo.email || userinfoAtsession.email}
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem>
                    <a href="/user">アカウント</a>
                  </DropdownItem>

                  <DropdownItem>
                    <a href="#" onClick={logout}>
                      ログアウト
                    </a>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            ) : null}
            {!layout.is_login ? (
              <NavItem>
                <Button
                  className="btn btn-outline-info"
                  onClick={loginToggle.bind(null)}
                >
                  {t("Login")}
                </Button>
              </NavItem>
            ) : null}
            {!layout.is_login ? (
              <NavItem>
                <Button
                  className="btn btn-info-gradiant"
                  onClick={registerToggle.bind(null)}
                  
                >
                  {t("Register")}
                </Button>
              </NavItem>
            ) : null}

            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav>
                {headerLangLabel} <i className="fa fa-angle-down m-l-5"></i>
              </DropdownToggle>
              <DropdownMenu
                className="b-none animate__animated animate__fadeInUp 
 animate__faster"
              >
                <DropdownItem>
                  <a onClick={changeLang.bind(this, "ja-jp")}>🇯🇵 日本語</a>
                </DropdownItem>
                <DropdownItem>
                  <a onClick={changeLang.bind(this, "en-us")}>🇺🇸 English</a>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Collapse>
      </Navbar>

      <LoginModal state={layout} dispatch={dispatch} />
      <RegisterModal state={layout} dispatch={dispatch} />
      <ForgetModal state={layout} dispatch={dispatch} />
      <ResetModal state={layout} dispatch={dispatch} />
      <BfxForgetModal state={layout} dispatch={dispatch} />
      <Login2faModal state={layout} dispatch={dispatch} />
      <PwdResetModal state={layout} dispatch={dispatch} />
    </div>
  );
};

export default connect(({ layout, dispatch }) => ({ layout, dispatch }))(HeaderComponent);
